export default "__VITE_ASSET__b7003e6c__"